export class LocalizedString {
  constructor(readonly fr: string = '',
    readonly en: string = '') { }
  static get empty(): LocalizedString {
    return new LocalizedString();
  }
}
